const doc = [({"en":({"js":({"admin":({"show_box_attributes":({"form":({"the_attribute_was_saved":"The attribute was saved."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;